import { FEATURE_FLAG } from '~/constants';

import { type RouteExportParams } from '~/types/router.type';

export const routeParams: RouteExportParams = {
  permissions: ['org_unit.'],
  featureFlag: FEATURE_FLAG.DATA_SYNC_UI,
};
